module.exports = __webpack_public_path__ + "dash_20_app_assets/img/tw.ec36b4f3.png";